<template>
  <div class="input-slider-main">
    <div>
      <q-item-label class="label-top">
        <slot
          name="title"
          class="ibf-amount4"
          >Show Between</slot
        >
      </q-item-label>
      <q-item-label class="label-bottom ibf-amount2">
        <slot
          name="subtitle"
          class="ibf-amount2"
          >{{ slideValue.min }}{{ labelValue }} - {{ slideValue.max }}{{ labelValue }}</slot
        >
      </q-item-label>
    </div>
    <div class="input-slider-holder">
      <q-range
        v-model="slideValue"
        class="input-slider"
        :min="showAttribute(minValue)"
        :max="showAttribute(maxValue)"
        :step="showAttribute(steps)"
        snap
        :label-value="slideValue + labelValue"
        :label="labelShown"
        @change="handleChange"
      ></q-range>
    </div>
    <div
      v-if="showMinMax"
      class="row slider-min-max ibf-amount6"
    >
      <div>{{ showAttribute(minValue) }}{{ labelValue }}</div>
      <div class="slider-min-max-right">{{ showAttribute(maxValue) }}{{ labelValue }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: {
        min: 0,
        max: 100,
      },
    },
    minValue: {
      default: 0,
    },
    maxValue: {
      default: 100,
    },
    steps: {
      default: 1,
    },
    labelValue: {
      default: '',
    },
    showMinMax: {
      default: true,
    },
    showHoverLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      slideValue: this.value,
      labelShown: true,
      // fontOfTheDay: '',
      // fontsList: ['ibf-amount4', 'ibf-text-list2', 'ibf-oneline2'],
    };
  },
  watch: {
    value: {
      handler() {
        this.slideValue.min = Math.round(this.value.min);
        this.slideValue.max = Math.round(this.value.max);
      },
      deep: true,
    },
  },
  beforeMount() {
    this.labelShown = this.showHoverLabel;
  },
  methods: {
    handleChange(e) {
      this.$emit('handleChange', e);
    },
    showAttribute(obj) {
      if (obj === 0) return parseFloat(obj);
      return obj && !Number.isNaN(obj) ? parseFloat(obj) : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-slider-main {
  width: 90%;
  margin: 5px auto;
}
.input-slider-holder {
  background: $-system-app-background;
  border: 1px solid $-system-app-grey-95;
  border-radius: 30px;
  :deep(.q-slider__track) {
    height: 2px !important;
    color: $-text--dark !important;
  }
  :deep(.q-slider__inner) {
    background: $-text--dark !important;
  }
}

.input-slider {
  display: block !important;
  width: 90%;
  height: 26px;
  margin: auto;
}

.label-top {
  margin: 5px;
  font-size: 10px;
  color: $-text-text-low-old;
}

.label-bottom {
  margin: 5px;
  padding-bottom: 5px;
}

:deep(*) {
  .q-slider__thumb-container:nth-child(1) {
    color: $-system-app-primary !important;
  }
}

.slider-min-max {
  width: 91%;
  margin: 5px auto;
  line-height: 12px;
  text-align: right;
  .slider-min-max-right {
    margin-left: auto;
    float: right;
  }
}
</style>
